<template>
  <a-modal v-model:open="visible" :title="modelTitle" @cancel="handleCancel" @ok="handleSave" okText="save"
    :confirmLoading="saveLoading" :maskClosable="false" width="720px" >
    <div class="edit-placement-content">
      <a-spin :spinning="spinning">
        <a-form ref="formRef" :model="formData" layout="vertical">
          <a-form-item v-if="pageType === 'rejected'" label="Reject Reason" name="rejectReason">
            <a-textarea :disabled="true" v-model:value="formData.rejectionReason" :maxlength="200"
              :auto-size="{ minRows: 3, maxRows: 5 }" disabled />
          </a-form-item>
          <a-form-item v-if="pageType === 'insufficient_stock'" label="Notice" name="rejectReason">
            <a-textarea :disabled="true" v-model:value="notice" :maxlength="200" :auto-size="{ minRows: 3, maxRows: 5 }"
              disabled />
          </a-form-item>
          <a-form-item label="Placement Name" name="name" :rules="rules.name">
            <a-input :disabled="setDisabled || pageType === 'approved'" v-model:value="formData.name" allow-clear
              :maxlength="100" />
          </a-form-item>
          <a-form-item label="Placement Description" name="description" :rules="rules.description">
            <a-textarea :disabled="setDisabled" v-model:value="formData.description" :maxlength="200"
              :auto-size="{ minRows: 3, maxRows: 5 }" allow-clear />

          </a-form-item>
          <a-form-item label="Specs" name="specifications" :rules="rules.specifications">
            <a-input :disabled="setDisabled" v-model:value="formData.specifications"
              placeholder="e.g. Recommend Image dimensions, file size, image format" allow-clear :maxlength="100" />

          </a-form-item>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="Price" name="price" :rules="rules.price">
                <a-input :disabled="setDisabled" type="number" v-model:value="formData.price" allow-clear :min="1.00"
                  step="0.01" :precision="2" @input="onPriceInput" @blur="onNumberBlur('price', 1, 999999999)"
                  @keydown="preventNumberWithDecimal">
                  <template #prefix>$</template>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Duration" name="durationDays" :rules="rules.durationDays">
                <a-input :disabled="setDisabled" type="number" v-model:value="formData.durationDays" :min="1" :max="999"
                  @input="onNumberInput($event, 'durationDays')" @blur="onNumberBlur('durationDays', 1, 999)"
                  @keydown="preventNonNumber" allowClear>
                  <template #suffix>Days</template>
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="AvailableFrom" name="availableFrom" :rules="rules.availableFrom">
                <a-date-picker :disabled="setDisabled" @change="handleAvailableFromChange" style="width: 100%"
                  v-model:value="formData.availableFrom" allowClear format="YYYY-MM-DD" :disabledDate="disabledDate" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Lead Time" name="leadTimeDays" :rules="rules.leadTimeDays">
                <a-input :disabled="setDisabled" type="number" :min="1" :max="999" v-model:value="formData.leadTimeDays"
                  @input="onNumberInput($event, 'leadTimeDays')" @blur="onNumberBlur('leadTimeDays', 1, 999)"
                  @keydown="preventNonNumber" allowClear>
                  <template #suffix>Days</template>
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="Auto-cancel Period(Business Days after acceptance)" name="autoCancelPeriodDays"
            :rules="rules.autoCancelPeriodDays">
            <a-input :disabled="setDisabled" type="number" v-model:value="formData.autoCancelPeriodDays" :min="1"
              :max="999" @input="onNumberInput($event, 'autoCancelPeriodDays')"
              @blur="onNumberBlur('autoCancelPeriodDays', 1, 999)" @keydown="preventNonNumber" allowClear>
              <template #suffix>Days</template>
            </a-input>
            <span class="auto-cancel-period-days-text"> Number of business days the brand has to complete payment before
              automatic
              cancellation.</span>
          </a-form-item>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="Available Inventory" name="availableInventory" :rules="rules.availableInventory">
                <a-input :disabled="setDisabled" type="number" v-model:value="formData.availableInventory" allowClear
                  @input="onNumberInput($event, 'availableInventory')" @blur="onNumberBlur('availableInventory', 1, 99)"
                  @keydown="preventNonNumber" :min="1" :max="99" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item name="autoAcceptRequests" :rules="rules.autoAcceptRequests">
                <template #label>
                  <span>Auto-Accept Request</span>
                  <a-tooltip placement="top">
                    <template #title>
                      <span> If set to "YES", the system will automatically accept advertising applications from
                        Brands.</span>
                    </template>
                    <Icon style="margin-left: 4px;" name="wenhao-tianchong" class="question-icon"></Icon>
                  </a-tooltip>

                </template>
                <a-select :disabled="setDisabled" v-model:value="formData.autoAcceptRequests" style="width:100%"
                  :options="autoAcceptRequestsOptions" allowClear></a-select>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="Available Link Type" name="linkType" :rules="rules.linkType">
                <a-select :disabled="setDisabled || pageType === 'approved'" v-model:value="formData.linkType"
                  style="width:100%" :options="options" allowClear></a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item name="maxAsinCount" :rules="rules.maxAsinCount">
                <template #label>
                  <span>Maximum Promotable ASINs</span>
                  <!-- <Icon style="margin-left: 4px;" name="wenhao-tianchong" class="question-icon"></Icon> -->
                </template>
                <a-input type="number" :disabled="setDisabled" :min="1" :max="50" v-model:value="formData.maxAsinCount"
                  @input="onNumberInput($event, 'maxAsinCount')" @blur="onNumberBlur('maxAsinCount', 1, 50)"
                  @keydown="preventNonNumber" allowClear />
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="Available Result Shown to Brands" name="availableResultTypes"
            :rules="rules.availableResultTypes">
            <a-checkbox-group v-model:value="formData.availableResultTypes" name="checkboxgroup" :options="plainOptions"
              :disabled="setDisabled" />
          </a-form-item>
          <a-form-item name="exampleFiles" label="Upload Examples" :rules="rules.exampleFiles">
            <artmisads-select-button :disabled="setDisabled" @click="uploadFile">
              Upload
            </artmisads-select-button>
            <div class="preview-container" v-if="formData.exampleFiles.length > 0">
              <div class="preview-item" v-for="item in formData.exampleFiles" :key="item.originalFileName">
                <a-image :src="item.url" alt="" width='120px' height='120px' :placeholder="true" />
                <div class="close" @click="handleRemoveItem(item)">
                  <Icon name="close-cu" class="close-icon"></Icon>
                </div>
              </div>
            </div>
      
            <!-- <div class="upload-container">
              <a-upload :disabled="setDisabled"
                accept=".jpg,.png,.jpeg,.gif,image/jpeg,image/png,image/jpg,image/gif"
                v-model:fileList="formData.upload" name="logo" max-count="10" :custom-request="customUpload"
                list-type="picture" @remove="handleRemove" :before-upload="beforeUpload" @change="handleUploadChange"
                :show-upload-list="true">
               
              </a-upload>

            </div> -->
          </a-form-item>
        </a-form>
      </a-spin>
    </div>
    <template #footer>
      <div style="overflow: hidden;">
        <a-button style="float: left" key="back" type="primary"
          v-if="pageType === 'add' || pageType === 'draft' || pageType === 'rejected'" :loading="loading"
          @click="handleSave('draft')" :disabled="isEmpty">Save as Draft</a-button>
        <a-button style="float: right" key="submit" type="primary" :loading="loading"
          v-if="pageType === 'add' || pageType === 'draft' || pageType === 'approved' || pageType === 'rejected' || pageType === 'insufficient_stock'"
          @click="handleSave('submit')">Submit</a-button>
        <a-button style="float: right" key="review" type="primary" :loading="loading" v-if="pageType === 'reviewing'"
          @click="handleSave('review')">Suspend</a-button>
      </div>

    </template>
    <UploadModel ref="uploadModelRef" :exampleFiles="formData.exampleFiles" @upload="handleUpload" />
  </a-modal>
</template>
<script setup>
import { ref, defineEmits, defineExpose, nextTick, computed, watch } from 'vue'
import { message } from 'ant-design-vue'
import Icon from "@/components/Icon.vue"
import dayjs from 'dayjs'
import { setTime } from '~/utils'
import adminApi from '~/server/seller/admin'
import { Modal } from 'ant-design-vue'
import { publisherPlacementApi, publisherApi } from '~/server/index'
import { useUserInfoStore } from '~/storeData/index'

const store = useUserInfoStore()
import UploadModel from './uploadModel.vue'
const loading = ref(false)
const formRef = ref(null)
const modelTitle = ref('Edit')
const emit = defineEmits(['refresh'])
const pageType = ref('')
const pageId = ref('')
const uploadModelRef = ref(null)
const spinning = ref(false)
const notice = ref('This placement is out of stock , brands can not request new campagin until you edit available Inventorys')
const formData = ref({
  rejectReason: '',
  autoCancelPeriodDays: "",
  name: '',
  description: '',
  specifications: '',
  price: '',
  durationDays: '',
  availableFrom: '',
  leadTimeDays: '',
  availableInventory: '',
  linkType: '',
  autoAcceptRequests: '',
  maxAsinCount: '',
  availableResultTypes: [],
  exampleFiles: []
})

// 保存原始数据用于对比
const originalData = ref({})
const handleRemoveItem = (itemFile) => {
  formData.value.exampleFiles = formData.value.exampleFiles.filter(item => item.url !== itemFile.url)
}
// 判断字段是否被修改
const isFieldModified = (fieldName) => {
  return originalData.value[fieldName] !== formData.value[fieldName]
}

// 归一化值，避免类型/格式差异导致的误判
const normalizeValue = (field, value) => {
  if (value === null || value === undefined) return ''
  
  // 数组字段特殊处理
  if (field === 'availableResultTypes') {
    if (Array.isArray(value)) {
      return JSON.stringify(value.sort()) // 排序后比较，避免顺序差异
    }
    if (value === null || value === undefined || value === '') {
      return '[]'
    }
    return '[]'
  }
  
  // 日期字段：转成 YYYY-MM-DD
  if (field === 'availableFrom') {
    const v = value
    // dayjs 对象
    if (v && typeof v === 'object' && typeof v.format === 'function') {
      return v.format('YYYY-MM-DD')
    }
    // 数组 [Y,M,D]
    if (Array.isArray(v) && v.length === 3) {
      const [y, m, d] = v
      const mm = String(m).padStart(2, '0')
      const dd = String(d).padStart(2, '0')
      return `${y}-${mm}-${dd}`
    }
    // 字符串
    if (typeof v === 'string') return v
    // 其它类型
    try { return String(v) } catch { return '' }
  }
  // 布尔/数字统一为字符串
  if (typeof value === 'boolean' || typeof value === 'number') return String(value)
  // 字符串去空白
  if (typeof value === 'string') return value.trim()
  // 其它对象用 JSON 序列化兜底
  try { return JSON.stringify(value) } catch { return '' }
}

// 检测用户是否有任何更改
const hasUserChanges = () => {
  // 检查所有表单字段是否有更改（统一归一化比较）
  const formFields = [
    'rejectReason', 'autoCancelPeriodDays', 'name', 'description',
    'specifications', 'price', 'durationDays', 'availableFrom',
    'leadTimeDays', 'availableInventory', 'linkType', 'autoAcceptRequests', 'maxAsinCount', 'availableResultTypes'
  ]

  for (const field of formFields) {
    const orig = normalizeValue(field, originalData.value[field])
    const curr = normalizeValue(field, formData.value[field])
    if (orig !== curr) {
      return true
    }
  }

  // 检查文件是否有更改
  if (originalData.value.exampleFiles?.length !== formData.value.exampleFiles?.length) {
    return true
  }

  // 检查文件内容是否有更改
  if (originalData.value.exampleFiles && formData.value.exampleFiles) {
    for (let i = 0; i < formData.value.exampleFiles.length; i++) {
      if (originalData.value.exampleFiles[i]?.url !== formData.value.exampleFiles[i]?.url) {
        return true
      }
    }
  }

  return false
}

// 检测草稿状态下是否有实际内容变化（非空且与原始值不同）
const hasActualDraftChanges = () => {
  // 检查表单是否真的有实际内容的变化
  const formFields = [
    'rejectReason', 'autoCancelPeriodDays', 'name', 'description',
    'specifications', 'price', 'durationDays', 'availableFrom',
    'leadTimeDays', 'availableInventory', 'linkType', 'autoAcceptRequests', 'maxAsinCount'
  ]
  
  let hasActualChanges = false
  for (const field of formFields) {
    const orig = normalizeValue(field, originalData.value[field])
    const curr = normalizeValue(field, formData.value[field])
    // 只有当字段有实际值且与原始值不同时，才认为有变化
    if (orig !== curr && curr.trim() !== '') {
      hasActualChanges = true
      break
    }
  }
  
  // 检查availableResultTypes数组是否有变化
  if (!hasActualChanges && JSON.stringify(originalData.value.availableResultTypes || []) !== JSON.stringify(formData.value.availableResultTypes || [])) {
    hasActualChanges = true
  }
  
  // 检查文件是否有变化
  if (!hasActualChanges && (originalData.value.exampleFiles?.length !== formData.value.exampleFiles?.length)) {
    hasActualChanges = true
  }
  
  return hasActualChanges
}

// 判断 description 和 specifications 是否被修改
const isDescriptionModified = computed(() => isFieldModified('description'))
const isSpecificationsModified = computed(() => isFieldModified('specifications'))

// 判断是否有任何字段被修改
const hasAnyFieldModified = computed(() => {
  return isDescriptionModified.value || isSpecificationsModified.value
})
const options = ref([
  { label: 'Associate', value: 'associate' },
  { label: 'Attribution', value: 'attribution' },
])
const plainOptions = ref([
  { label: 'Screenshots', value: 'screenshots' },
  { label: 'Impressions', value: 'impressions' },
  { label: 'Clicks', value: 'clicks' },
])
const autoAcceptRequestsOptions = ref([
  { label: 'Yes', value: true },
  { label: 'No', value: false }
])
const rules = ref({
  name: [{ required: true, message: 'Placement Name is required' }],
  description: [{ required: true, message: 'Placement Description is required' }],
  specifications: [{ required: true, message: 'Specs is required' }],
  price: [{ required: true, message: 'Price is required' }],
  durationDays: [{ required: true, message: 'Duration is required' }],
  availableFrom: [{ required: true, message: 'AvailableFrom is required' }],
  leadTimeDays: [{ required: true, message: 'Lead Time is required' }],
  autoCancelPeriodDays: [{ required: true, message: 'Auto-cancel Period(Business Days after acceptance) is required' }],
  availableInventory: [{ required: true, message: 'Available Inventory is required' }],
  linkType: [{ required: true, message: 'Available Link Type is required' }],
  autoAcceptRequests: [{ required: true, message: 'Auto-Accept Request is required' }],
  maxAsinCount: [{ required: true, message: 'Maximum Promotable ASINs is required' }],
  exampleFiles: [
    {
      required: true,
      message: 'Upload is required'
    },
    {
      validator: (rule, value) => {
        if (!value || !Array.isArray(value) || value.length === 0) {
          return Promise.reject('Please upload at least one example file')
        }
        return Promise.resolve()
      }
    }
  ]
})

const uploadImageUrl = ref('')
const visible = ref(false)
const saveLoading = ref(false)
const type = ref('edit')
// 价格字段范围常量
const PRICE_MIN = 1
const PRICE_MAX = 1000000.00

// 文件上传前的验证
const beforeUpload = (file) => {
  const allowedTypes = [

    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
  ]

  const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif']

  const isValidType = allowedTypes.includes(file.type)
  const isValidExtension = allowedExtensions.some(ext =>
    file.name.toLowerCase().endsWith(ext)
  )

  if (!isValidType && !isValidExtension) {
    message.error('Only  jpg, png, jpeg, gif files are supported') // 英文  只支持上传 zip、jpg、png、jpeg、pdf、rar 格式的文件
    return false
  }

  const isLt10M = file.size / 1024 / 1024 < 10
  if (!isLt10M) {
    message.error('File size cannot exceed 10MB!')
    return false
  }

  return true
}
function getBase64 (img, callback) {
  const reader = new FileReader()

  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
// const handleRemove = (file) => {
//   // console.log(file, 'file')
//   exampleFiles.value = exampleFiles.value.filter(item => item.originalFileName !== file.name)
//   // console.log(exampleFiles.value,'exampleFiles.value')
// }
// 自定义上传处理
// const customUpload = (options) => {
//   const { file, onSuccess, onError, onProgress } = options

//   const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif']

//   const isValidExtension = allowedExtensions.some(ext =>
//     file.name.toLowerCase().endsWith(ext)
//   )
//   loading.value = true
//   if (isValidExtension) {
//     const data = {}

//     if (file) {
//       data.file = file
//     } else {
//       data.url = encodeURIComponent(uploadImageUrl.value)
//     }
//     // 模拟上传进度
//     adminApi.uploadImg(data).then((res) => {

//       onSuccess({
//         url: URL.createObjectURL(file),
//         name: file.name,
//         status: 'done'
//       })
//       exampleFiles.value.push({
//         originalFileName: file.name,
//         url: res.data.url
//       })
//     }).catch(e => {
//       console.log(e)
//     }).finally(() => {
//       loading.value = false
//     })
//   }
// }
const setDisabled = computed((name) => {
  // console.log(name, 'name')
  return pageType.value === 'reviewing'
})


// 处理上传状态变化
const handleUploadChange = (info) => {
  const { file, fileList } = info
  // if (info.file.status === 'uploading') {
  //   spinning.value = true;
  //   return
  // }

  if (file.status === 'done') {
    getBase64(file.originFileObj, (base64Url) => {
      uploadImageUrl.value = base64Url
    })
  }
  // 如果上传失败，清除错误状态
  if (file.status === 'error') {
    message.error('Upload failed. Please try again.')
    // 自动清除失败的文件
    setTimeout(() => {
      formData.value.upload = fileList.filter(item => item.status !== 'error')
    }, 2000)
  }

  // 如果上传成功
  // if (file.status === 'done') {
  //   message.success('File uploaded successfully!')
  // }
}

// 清除错误文件
const clearErrorFiles = () => {
  formData.value.upload = formData.value.upload.filter(item => item.status !== 'error')
  message.success('Error files cleared!')
}

// 清除所有文件
const clearAllFiles = () => {
  formData.value.upload = []
  message.success('All files cleared!')
}

const handleCancel = async () => {
  
  // 新增模式或编辑模式且用户没有任何更改，直接关闭
  if (!hasUserChanges()) {
    visible.value = false
    return
  }

  visible.value = true
  if (pageType.value === 'approved' || pageType.value === 'insufficient_stock') {
    Modal.confirm({
      title: 'Notice',
      content: 'Your changes may be lost if you close this window. Are you sure you want to continue?',
      onOk: async () => {

      },
      onCancel: () => {
        visible.value = false
      },

      okText: 'Cancel',
      cancelText: 'Close',
      wrapClassName: 'reverse-confirm-btns' // 加这一行
    })
  } else {
    // 对于draft状态，使用封装的方法检查是否有实际变化
    if (pageType.value === 'draft') {
      // 如果没有实际变化，直接关闭
      if (!hasActualDraftChanges()) {
        visible.value = false
        return
      }
    }
    
    Modal.confirm({
      title: 'Notice',
      content: 'Do you want to save the filled information as draft?',
      onOk: async () => {
        handleSave('draft')
      },
      onCancel: () => {
        visible.value = false
      },

      okText: 'Save as Draft',
      cancelText: 'Close',
      wrapClassName: 'reverse-confirm-btns' // 加这一行
    })
  }


}
const isShallowEmpty = (obj) => {
  if (!obj || typeof obj !== 'object') return true
  return Object.values(obj).every(v =>
    v === null ||
    v === undefined ||
    (typeof v === 'string' && v.trim() === '') ||
    (Array.isArray(v) && v.length === 0)
  )
}
const isEmpty = ref(true)
watch(() => formData.value, (newVal) => {
  if (isShallowEmpty(newVal)) {
    isEmpty.value = true
  } else {
    isEmpty.value = false
  }
}, { deep: true, immediate: true })
// 使用

const handleUpload = (filesArray) => {

  formData.value.exampleFiles = filesArray
}
const handleSave = async (type) => {
  saveLoading.value = true
  let data = null
  // exampleFiles.value.forEach(item => {
  //   formData.value.upload.forEach(item2 => {
  // })
  // console.log(exampleFiles.value, 'exampleFiles.value')
  // return
  let params = {
    ...formData.value,
    currency: "USD",
    availableFrom: formData.value.availableFrom ? dayjs(formData.value.availableFrom).format('YYYY-MM-DD') : ''
  }
  if (params.availableInventory) {
    params.availableInventory = Number(params.availableInventory)
  }
  if (type === 'review') {
    Modal.confirm({
      title: 'Notice',
      content: 'Are you sure to suspend reviewing this placement? This will change status to Draft and you can re-submit it later again.',
      onOk: async () => {
        data = await publisherPlacementApi.suspendPlacement(pageId.value)
        if (data.success) {
          message.success(`Suspend Successfully`)
          emit('refresh')
          visible.value = false
        } else {
          message.error(data.error)
        }
      }
    })
  }
  if (type === 'draft') {
    if (pageType.value === 'add') {
      data = await publisherPlacementApi.saveDraft(params)
    }
    if (pageType.value === 'draft' || pageType.value === 'rejected') {
      params.saveStatus = 'draft'
      data = await publisherPlacementApi.updatePlacement({ id: pageId.value, data: params })
    }
    if (data.success) {
      message.success(`Save as Draft Successfully`)
      visible.value = false
      emit('refresh')
    } else {
      message.error(data.error)
    }

    // 草稿保存不进行校验，直接结束
    saveLoading.value = false
    return
  }
  formRef.value.validate().then(async res => {
    if (type === 'submit') {
      if (pageType.value === 'approved' || pageType.value === 'insufficient_stock') {
        // 检查是否有字段被修改
        if (hasAnyFieldModified.value) {
          if (isDescriptionModified.value || isSpecificationsModified.value) {
            // console.log('- description 已修改')
            Modal.confirm({
              title: 'Notice',
              content: 'Your changes to the placement information require a review. Confirm submission?',
              onOk: async () => {
                data = await publisherPlacementApi.updatePlacement({ id: pageId.value, data: params })
                if (data.success) {
                  message.success(`Submit Successfully`)
                  emit('refresh')
                  visible.value = false
                } else {
                  message.error(data.error)
                }
              }
            })
          }
        } else {
          Modal.confirm({
            title: 'Notice',
            content: 'Please verify all information is correct.Your changes will be submitted upon confirmation.',
            onOk: async () => {
              data = await publisherPlacementApi.updatePlacement({ id: pageId.value, data: params })
              if (data.success) {
                message.success(`Submit Successfully`)
                emit('refresh')
                visible.value = false
              } else {
                message.error(data.error)
              }
            }
          })
        }


      }
      else {
        Modal.confirm({
          title: 'Notice',
          content: 'Please verify all information is correct.Your changes will be submitted upon confrmation.',
          onOk: async () => {
            if (pageType.value === 'add') {
              data = await publisherPlacementApi.addPlacement(params)
            }
            if (pageType.value === 'draft' || pageType.value === 'rejected' || pageType.value === 'insufficient_stock') {
              params.saveStatus = 'reviewing'
              data = await publisherPlacementApi.updatePlacement({ id: pageId.value, data: params })
            }

            if (data.success) {
              message.success(`Submit Successfully`)
              emit('refresh')
              visible.value = false
            } else {
              message.error(data.error)
            }
          }
        })
      }

    }

    //  else if (type === 'review') {
    //   Modal.confirm({
    //     title: 'Notice',
    //     content: 'Are you sure to suspend reviewing this placement? This will change status to Draft and youcan re-submit it later again.',
    //     onOk: async () => {
    //       data = await publisherPlacementApi.suspendPlacement(pageId.value)
    //       if (data.success) {
    //         message.success(`Suspend Successfully`)
    //         emit('refresh')
    //         visible.value = false
    //       }
    //     }
    //   })
    // }

    if (data.success) {

      emit('refresh')
      visible.value = false
    }
  }).catch((err) => {
    console.log(err, 'err')
  }).finally(() => {
    saveLoading.value = false
  })
}
const handleAvailableFromChange = (date) => {
  // console.log('e',e)
  // if (date) {
  //   const selectedEndDate = dayjs(date).format('YYYY-MM-DD')
  //   formData.value.availableFrom = selectedEndDate
  // }
}

const handlePrice = (e) => {
  let value = parseFloat(e.target.value)
  if (isNaN(value)) {
    formData.value.price = ''
    return
  }
  if (value < PRICE_MIN) value = PRICE_MIN
  if (value > PRICE_MAX) value = PRICE_MAX
  formData.value.price = value.toFixed(2)
}

// 阻止输入非数字字符（e/E/+/−/./等），允许功能键和导航键
const preventNonNumber = (event) => {
  const blockedKeys = ['e', 'E', '+', '-', '.', ',', '–', '—']
  const allowedKeyCodes = [8, 9, 13, 27, 35, 36, 37, 38, 39, 40, 46] // Backspace, Tab, Enter, Esc, Home, End, Arrows, Delete
  const isCtrlCmdCombo = event.ctrlKey || event.metaKey

  // 允许组合键如 Ctrl/Cmd + A/C/V/X/Z/Y
  if (isCtrlCmdCombo) return
  // 允许导航/功能键
  if (allowedKeyCodes.includes(event.keyCode)) return
  // 阻止非数字和指定字符
  if (blockedKeys.includes(event.key)) {
    event.preventDefault()
  }
}

// 价格输入允许一个小数点，禁止 e/E/+/−/逗号
const preventNumberWithDecimal = (event) => {
  const blockedKeys = ['e', 'E', '+', '-', ',', '–', '—']
  const allowedKeyCodes = [8, 9, 13, 27, 35, 36, 37, 38, 39, 40, 46]
  const isCtrlCmdCombo = event.ctrlKey || event.metaKey
  if (isCtrlCmdCombo) return
  if (allowedKeyCodes.includes(event.keyCode)) return
  if (event.key === '.') {
    if (String(formData.value.price || '').includes('.')) {
      event.preventDefault()
    }
    return
  }
  if (!/\d/.test(event.key) || blockedKeys.includes(event.key)) {
    event.preventDefault()
  }
}

// 通用数字输入过滤：仅保留数字；价格字段单独处理小数两位
const onNumberInput = (e, field) => {
  const raw = e?.target?.value ?? ''
  if (field === 'price') {
    let filtered = String(raw).replace(/[^\d.]/g, '')
    const firstDot = filtered.indexOf('.')
    if (firstDot !== -1) {
      filtered = filtered.slice(0, firstDot + 1) + filtered.slice(firstDot + 1).replace(/\./g, '')
    }
    const parts = filtered.split('.')
    if (parts.length === 2) {
      parts[1] = parts[1].slice(0, 2)
      filtered = parts[0] + '.' + parts[1]
    }
    // 限制整数位长度：最多 9 位（支持最大 999,999,999.99）
    if (parts[0].length > 9) {
      parts[0] = parts[0].slice(0, 9)
      filtered = parts[0] + (parts.length === 2 ? '.' + parts[1] : '')
    }
    if (filtered !== '' && filtered !== '.' && !filtered.startsWith('0.')) {
      filtered = String(parseInt(parts[0] || '0', 10)) + (parts.length === 2 ? '.' + parts[1] : '')
    }
    formData.value.price = filtered
    return
  }
  const digitsOnly = String(raw).replace(/[^\d]/g, '')
  formData.value[field] = digitsOnly
}

// 通用数字失焦校正：限定最小最大且转为整数字符串
const onNumberBlur = (field, min, max) => {
  let value = formData.value[field]
  if (value === '' || value === null || value === undefined) {
    formData.value[field] = ''
    return
  }
  // 特殊处理价格：保留两位小数并按范围
  if (field === 'price') {
    const min = PRICE_MIN
    const max = PRICE_MAX
    let num = parseFloat(String(value))
    if (isNaN(num)) {
      formData.value.price = ''
      return
    }
    if (num < min) num = min
    if (num > max) num = max
    formData.value.price = num.toFixed(2)
    return
  }

  let num = parseInt(String(value), 10)
  if (isNaN(num)) {
    formData.value[field] = ''
    return
  }
  if (num < min) num = min
  if (num > max) num = max
  formData.value[field] = String(num)
}

// 禁用过去的日期
const disabledDate = (current) => {
  // 禁用今天之前的日期
  return current && current < dayjs().startOf('day')
}

const getPlacementById = async () => {
  spinning.value = true
  const res = await publisherPlacementApi.getPlacementById(pageId.value)
  formData.value = res.data
  // 确保 availableResultTypes 是数组
  if (!Array.isArray(formData.value.availableResultTypes)) {
    formData.value.availableResultTypes = []
  }
  // 使用 dayjs 解析日期，避免时区问题
  // dayjs 默认使用本地时区解析，如果需要 UTC 模式可以使用 dayjs.utc()
  const dateString = res.data.availableFrom ? setTime(res.data.availableFrom,false) : ''
  formData.value.availableFrom = dateString ? dayjs(dateString) : ""
  // formData.value.upload = formData.value.exampleFiles.map(item => {
  //   return {
  //     url: item.url,
  //     name: item.originalFileName
  //   }
  // })


  // 保存原始数据用于对比修改（统一格式，避免误判）
  originalData.value = {
    rejectReason: res.data.rejectReason ?? '',
    autoCancelPeriodDays: res.data.autoCancelPeriodDays ?? '',
    name: res.data.name ?? '',
    description: res.data.description ?? '',
    specifications: res.data.specifications ?? '',
    price: res.data.price ?? '',
    durationDays: res.data.durationDays ?? '',
    // 存源字符串日期，避免与 dayjs 对象比较产生误判
    availableFrom: setTime(res.data.availableFrom,false),
    leadTimeDays: res.data.leadTimeDays ?? '',
    availableInventory: res.data.availableInventory ?? '',
    linkType: res.data.linkType ?? '',
    autoAcceptRequests: res.data.autoAcceptRequests ?? '',
    maxAsinCount: res.data.maxAsinCount ?? '',
    availableResultTypes: res.data.availableResultTypes ?? [],
    exampleFiles: Array.isArray(res.data.exampleFiles) ? res.data.exampleFiles.map(it => ({ url: it.url })) : []
  }

  spinning.value = false
  // console.log(formData.value,'res')

}
const uploadFile = () => {

  uploadModelRef.value.show()
}
const open = ({ title, id, type }) => {
  modelTitle.value = title
  visible.value = true
  pageType.value = type
  // exampleFiles.value=[]
  formData.value = {
    rejectReason: '',
    autoCancelPeriodDays: "",
    name: '',
    description: '',
    specifications: '',
    price: '',
    durationDays: '',
    availableFrom: '',
    leadTimeDays: '',
    availableInventory: '',
    linkType: '',
    autoAcceptRequests: '',
    maxAsinCount: '',
    availableResultTypes: [],
    exampleFiles: []
  }
  if (store.userInfo.associateEnabled == 'Y') {
    options.value = [
      { label: 'Associate', value: 'associate' },
      { label: 'Attribution', value: 'attribution' },
    ]
  }
  else {
    options.value = [

      { label: 'Attribution', value: 'attribution' },
    ]
  }
  if (id) {
    formRef.value?.clearValidate()
    pageId.value = id
    getPlacementById()
  } else {
    // 新建模式下，保存初始空数据作为原始数据
    originalData.value = {
      rejectReason: '',
      autoCancelPeriodDays: '',
      name: '',
      description: '',
      specifications: '',
      price: '',
      durationDays: '',
      // 新建模式统一保存空字符串，比较时走 normalize
      availableFrom: '',
      leadTimeDays: '',
      availableInventory: '',
      linkType: '',
      autoAcceptRequests: '',
      maxAsinCount: '',
      availableResultTypes: [],
      exampleFiles: []
    }
    nextTick(() => {
      formRef.value?.resetFields()
      formRef.value?.clearValidate()
    })
  }
}

defineExpose({
  visible,
  handleCancel,
  handleSave,
  open
})
</script>
<style>
/* 全局样式文件里 */
.reverse-confirm-btns .ant-modal-confirm-btns {
  display: flex;
  flex-direction: row-reverse;
  /* 让确定按钮显示在左，取消在右 */
  gap: 16px;
}
</style>
<style lang="less" scoped>
.edit-placement-content{
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
}
.preview-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 16px 0;

  .preview-item {
    position: relative;
    overflow: hidden;
    width: 120px;
    height: 120px;
    border-radius: 8px;
    border: 1px solid #E8E5ED;
    background-color: #E8E5ED;
    display: flex;
    align-items: center;
    justify-content: center;

    :deep(img) {
      object-fit: contain;
      max-height: 120px !important;
    }

    .close {
      z-index: 10;
      position: absolute;
      top: 0;
      right: 0;
      width: 22px;
      height: 22px;
      border-radius: 0 0 0 8px;
      background-color: rgba(15, 6, 41, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .close-icon {
        width: 12px;
        height: 12px;
        color: #fff;
      }
    }
  }
}

.upload-container {
  .upload-actions {
    margin-top: 8px;
    display: flex;
    gap: 8px;
  }
}

.auto-cancel-period-days-text {
  font-size: 12px;
  color: var(--dark-2);
  margin-top: 4px;
  // margin-left: 8px;
}

:deep(.ant-upload-list-item-error) {
  border-color: #ff4d4f !important;
}

:deep(.ant-upload-list-item-error .ant-upload-list-item-name) {
  color: #ff4d4f !important;
}
</style>